module.exports = __webpack_public_path__ + "static/media/CakeShop.ddc3ff5c.png";